/**
      *********************************************************
      Description: Textbox component. .
      Required props:  type,value.
      limitations    : N/A.
      *********************************************************
**/

import React from "react";


export default function Link(props) {
    const { value, handleFieldValue, multiline, extraProps, rowsMax, shareProps, error, required, tooltip,
        contexthelp, disabled, changefieldto, linkurl, FieldIsSpellCheck, ...otherProps } = props
    const { label, helperText, name, xtype, fullWidth, ...otherConfigs } = otherProps;

    return (
        <div style={{ color: 'blue', fontSize: '12px' }}>
            <span
                 onClick={() => { window.open((value || linkurl), '_blank').focus(); }}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                className="clickable-label"
            >
                {label}
            </span>
        </div>
    )
}